import React from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    setCcComplianceSelectedItemIds,
} from "client/store"
import {
    CheckButton,
    TableGroupedIds,
    TableNestedIds,
} from "client/components"

interface SelectAllProps {
    title?: string
}

const InputSelectAll = ({
    title = null,
}: SelectAllProps) => {
    const itemGroupedIds = useSelector((state: StoreType) => state.ccCompliance.itemGroupedIds)
    const selectedItemIds = useSelector((state: StoreType) => state.ccCompliance.selectedItemIds)
    const visibleItemIds = useSelector((state: StoreType) => state.ccCompliance.visibleItemIds)
    const dispatch = useDispatch()

    const visibleSelected = selectedItemIds.filter((id) => visibleItemIds.includes(id))
    const selectedAll = visibleItemIds.length === visibleSelected.length && visibleItemIds.length > 0

    const selectAll = () => {
        if (selectedAll) {
            dispatch(setCcComplianceSelectedItemIds([]))
        } else {
            // select all visible items with sub-items
            const selected: number[] = []

            const addNestedItems = (nested: readonly TableNestedIds[]) => {
                nested.forEach((item) => {
                    selected.push(Number(item.id))
                    addNestedItems(item.nestedIds)
                })
            }
            const checkNestedGroups = (nested: readonly TableGroupedIds[]) => {
                nested.forEach((group) => {
                    group.nestedIds.forEach((nestedItem) => { // top level of nested items
                        const itemId = Number(nestedItem.id)
                        if (visibleItemIds.includes(itemId)) {
                            selected.push(itemId)
                            addNestedItems(nestedItem.nestedIds)
                        }
                    })
                    checkNestedGroups(group.nestedGroupedIds)
                })
            }
            checkNestedGroups(Object.values(itemGroupedIds))

            dispatch(setCcComplianceSelectedItemIds(selected))
        }
    }

    return (
        <CheckButton
            title={title}
            checked={selectedAll}
            padding={false}
            margin={false}
            onChange={selectAll}
        />
    )
}
export default InputSelectAll
